
export enum ConfigurationValueTypeCd {
	BOOLEAN = 'Boolean',
	NUMBER = 'Number',
	STRING = 'String'}
